import { User } from '../User';
import s from './userBlock.module.css';

export function UserBlock() {
  return (
    <div className={s.userBlock}>
      <User />
    </div>
  );
}
